import 'openblock-blocks/arduino_compressed';
import 'openblock-blocks/python_compressed';
import ScratchBlocks from 'openblock-blocks';
import {patchArduinoListPrint} from './patch-arduino-list-print';

import {DeviceType} from './device';

// Garante o patch também quando o gerador Arduino é carregado via code-generator.
patchArduinoListPrint(ScratchBlocks);

const getGeneratorNameFromDeviceType = deviceType => {
    if (deviceType === DeviceType.arduino) {
        return 'Arduino';
    } else if (deviceType === DeviceType.python ||
        deviceType === DeviceType.microPython ||
        deviceType === DeviceType.microbit) {
        return 'Python';
    }
    return 'null';
};

export {
    getGeneratorNameFromDeviceType
};
